import type { Step, StepStatus } from "./ChangeProcess.types";

function updateStepStatus<TChange extends { steps: object }>(
  change: TChange,
  step: keyof TChange["steps"],
  status: StepStatus,
  onUpdateProcess: (change: TChange) => Promise<void>
) {
  const steps = change.steps as Record<keyof TChange["steps"], Step>;
  return onUpdateProcess({
    ...change,
    steps: {
      ...change.steps,
      [step]: { ...steps[step], done: status }
    }
  });
}

export { updateStepStatus };
